'use client'

import Link from 'next/link'

import { Button } from '@/components/ui/button'
import useLogin from '@/hooks/use-login'
import useReadMineUserQueryWhenLogin from '@/hooks/use-read-mine-user-query-when-login'
import { cn } from '@/lib/utils'

export default function Join() {
  const { data: mineUser } = useReadMineUserQueryWhenLogin()
  const onLogin = useLogin()
  const className = cn(
    'h-[3.5rem] w-[10.75rem] rounded-full text-xl font-bold flex items-center justify-center',
    'bg-[url("/home-images/join-button-background.png")] hover:bg-[url("/home-images/join-button-hover-background.png")] bg-no-repeat bg-contain',
    'shadow-[0_2px_18px_2px_#D2DDFF_inset,_0_1px_4px_2px_#D2DDFF_inset,_0_42px_107px_0_rgba(138,167,255,0.34),_0_24.721px_32.257px_0_rgba(138,167,255,0.19),_0_10.268px_13.398px_0_rgba(138,167,255,0.22),_0_3.714px_4.846px_0_rgba(138,167,255,0.3)]',
  )

  if (mineUser) {
    return (
      <Link
        className={className}
        href={`/account/${mineUser.id}`}
      >
        Account
      </Link>
    )
  }

  return <Button onClick={onLogin} size="lg" variant="secondary" className={className}>Join</Button>
}
